import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { digitsOnly, formatPhone } from '../utils/phone';
import { PhoneChangeForm } from './PhoneChangeForm';

interface PhoneChangeSectionProps {
  // Display value (010-XXXX-XXXX) or null when never set. PRD 20 §3.3 says
  // sign-up guarantees a phone, so null is only a defensive fallback.
  currentPhone: string | null;
}

// PRD 20 §3.3.1 — Card 1 phone row. Read-only display + [변경] toggle that
// expands the edit area below. Re-keying the form on collapse resets all of
// its local state (matches the prototype's fullPhoneReset behavior).
export function PhoneChangeSection({ currentPhone }: PhoneChangeSectionProps) {
  const { t } = useTranslation('my-profile');
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="form-field" style={{ marginBottom: 16 }}>
      <label className="form-field__label" htmlFor="mpPhoneCurrent">
        {t('cards.info.fields.phone')}
      </label>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <input
          id="mpPhoneCurrent"
          type="tel"
          className="form-field__input"
          style={{ background: '#f9fafb', cursor: 'default', flex: 1 }}
          value={currentPhone ? formatPhone(digitsOnly(currentPhone)) : t('states.empty')}
          readOnly
        />
        <button
          type="button"
          className={`btn btn-default ${expanded ? 'btn-secondary' : 'btn-outline'}`}
          style={{ height: 40, minWidth: 80, fontWeight: 500 }}
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? t('phoneChange.toggle.cancel') : t('phoneChange.toggle.edit')}
        </button>
      </div>

      {expanded && (
        <PhoneChangeForm
          currentPhoneDigits={digitsOnly(currentPhone ?? '')}
          onSaved={() => setExpanded(false)}
        />
      )}
    </div>
  );
}
